import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AppActionButtonComponent } from '../../core/ui/action-button/app-action-button.component';

export type AppTourWelcomeResult = 'start' | 'dismiss';

@Component({
    standalone: true,
    selector: 'app-tour-welcome-dialog',
    imports: [MatDialogModule, TranslateModule, AppActionButtonComponent],
    template: `
        <h2 mat-dialog-title>{{ 'tour.app.welcome.title' | translate }}</h2>
        <mat-dialog-content>
            <p>{{ 'tour.app.welcome.body' | translate }}</p>
        </mat-dialog-content>
        <mat-dialog-actions align="end" class="gap-2">
            <app-action-button
                variant="secondary"
                [label]="'tour.app.welcome.dismiss' | translate"
                (click)="ref.close('dismiss')"
            />
            <app-action-button
                variant="primary"
                [label]="'tour.app.welcome.start' | translate"
                (click)="ref.close('start')"
            />
        </mat-dialog-actions>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppTourWelcomeDialogComponent {
    readonly ref = inject(MatDialogRef<AppTourWelcomeDialogComponent, AppTourWelcomeResult>);
}
